import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGameState } from './GameStateContext'; // Ensure correct import
import MFGif from './MF.gif'; // Adjust the path as necessary
import LogoImage from './Logo1.png';
import Tutorial from './Tutorial'; // Import Tutorial component
import './App.css'; // Ensure this path is correct for your CSS

const StartScreen = () => {
    const navigate = useNavigate();
    const { setPlayerName, startMusic } = useGameState(); // Make sure startMusic is defined in GameStateContext
    const [name, setName] = useState('');
    const [showTutorial, setShowTutorial] = useState(false);

    const handleStartClick = () => {
        if (name.trim()) {
            setPlayerName(name.trim());
            navigate('/game');
        } else {
            alert('Please enter your name.');
        }
    };

    const handleTutorialStart = () => {
        setShowTutorial(true);
    };

    const handleVibeButtonClick = () => {
        startMusic(); // Trigger music play
    };

    const onTutorialEnd = () => {
        setShowTutorial(false);
        navigate('/game');
    };

    return (
        <div style={{ 
            backgroundColor: '#FF973E', 
            height: '100vh', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center', 
            alignItems: 'center',
            color: 'white',
            position: 'relative',
            fontFamily: 'Dirty Brush, sans-serif'
        }}>
            {showTutorial ? (
                <Tutorial onTutorialEnd={onTutorialEnd} />
            ) : (
                <>
                    <img src={LogoImage} alt="Logo" style={{ position: 'absolute', top: '2%', left: '50%', transform: 'translateX(-50%)', width: '33%', height: 'auto' }} />
                    <h1 style={{ fontFamily: 'Dirty Brush, sans-serif' }}>It all started with a single CHOP</h1>
                    <input 
                        type="text"
                        placeholder="Discord username?"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        style={{
                            fontSize: '20px',
                            margin: '10px 0',
                            padding: '10px',
                            fontFamily: 'Dirty Brush, sans-serif'
                        }}
                    />
                    <button 
                        onClick={handleStartClick} 
                        style={{
                            fontSize: '20px',
                            padding: '10px 20px',
                            cursor: 'pointer',
                            margin: '10px 0',
                            fontFamily: 'Dirty Brush, sans-serif'
                        }}
                    >
                        CHOP CHOP
                    </button>
                    <button 
                        onClick={handleTutorialStart} 
                        style={{
                            fontSize: '20px',
                            padding: '10px 20px',
                            cursor: 'pointer',
                            margin: '10px 0',
                            fontFamily: 'Dirty Brush, sans-serif'
                        }}
                    >
                        How to Play?
                    </button>
                    <button 
                        onClick={handleVibeButtonClick} 
                        style={{
                            fontSize: '20px',
                            padding: '10px 20px',
                            cursor: 'pointer',
                            margin: '10px 0',
                            fontFamily: 'Dirty Brush, sans-serif'
                        }}
                    >
                        Vibe?
                    </button>
                    <img src={MFGif} alt="Animated GIF" style={{ width: '40%', height: 'auto', position: 'absolute', right: '5%', bottom: '0px', zIndex: 0 }} />
                </>
            )}
        </div>
    );
};

export default StartScreen;
